import { http } from '@/http/axios.js';

export function getFinanceOrderListAPI(params) {
  return http({
    url: '/admin/finance/order/page',
    method: 'get',
    params
  })
}
export function getOrderUnPayBillListAPI(params) {
    return http({
        url: '/admin/finance/orderBill/unpay/list',
        method: 'get',
        params
    })
}
export function addBalanceAPI(data) {
    return http({
        url: '/admin/finance/order/balance/add',
        method: 'post',
        data
    })
}
export function handleOrderBillOffLinePayAPI(data) {
  return http({
    url: '/admin/finance/orderBill/offline/pay',
    method: 'post',
    data
  })
}
export function getOfflineResultAPI(data) {
  return http({
    url: '/admin/finance/orderBill/offline/calc',
    method: 'post',
    data
  })
}
export function submitLockAPI(data) {
    return http({
        url: '/admin/order/device/lock',
        method: 'post',
        data
    })
}
